import { PropTypes } from 'prop-types';
import { useSelector } from "react-redux";
import { DecodeHtml } from "../../utils/decodeHtml";
const AboutUniten = () => {

    const state = useSelector(state => state.aboutUnitenContent)
   


    const aboutUniten = state?.data?.properties

    const title = aboutUniten?.title
    const description = DecodeHtml({ html: aboutUniten?.richTextContent?.markup })







    // const images = [
    //     "/assets/foundingFather1.svg",
    //     "/assets/foundingFather2.svg",


    // ]
    // const history = [
    //     {
    //         year: "1976 - 1993",
    //         paragraphs: [
    //             `Under the leadership of Tan Sri Dato’ (Dr.) Ir. Abu Zarim Omar, the National Electricity Board’s (NEB), vision of establishing an institution of higher learning to train future corporate leaders was translated into reality. In 1976, the Institut Latihan Sultan Ahmad Shah (ILSAS) was set up for the development of the staff potential and intellectual capital. The main purpose of ILSAS was to be the in-house training centre for NEB and to provide manpower training to fulfil the nation’s industrial needs.`,

    //         ]
    //     },
    //     {
    //         year: "1994 - 2000",
    //         paragraphs: [
    //             `In 1994, Tan Sri Dato’ (Dr.) Ani Arope, envisioned something greater for ILSAS. He was the driving force behind the upgrading of ILSAS to Institut Kejuruteraan Teknologi Tenaga Nasional (IKATAN). He was instrumental in establishing twinning degree programmes between IKATAN, Lincoln University, New Zealand, IUPUI and Ohio University, USA and University Malaya.`,
    //             `The Asian financial crisis in the late 1990’s forced the government to reduce the number of scholarships for students to be sent overseas. The three government-linked companies namely TNB, Telekom and Petronas, were invited by the Minister of Education Malaysia in 1996 to set up their own private universities. Tan Sri Dr. Ir. Ahmad Tajuddin Ali who then was the Executive Chairman of TNB played an important role in accepting the invitation and coming up with a plan to face the challenge. He was also instrumental in coming up with the name Universiti Tenaga Nasional or UNITEN and the infrastructure development of the campus.`,
    //             `On 1 September 1997, Universiti Tenaga Nasional Sdn Bhd began its operation in Putrajaya Campus.`,


    //         ]
    //     },
    //     {
    //         year: "2001 - 2006",
    //         paragraphs: [
    //             `In 2001, Dato’ Prof. Ir. Dr. Zainul Abidin Md. Shariff took over the duties of running the university from Dr. Tajul Arus bin Noh. The new Vice Chancellor served the university with distinction until his retirement in 2006.`,
    //             `Another significant occasion took place in 2005 when His Excellency Tun Dato’ Seri Utama (Dr.) Abdul Rahman Abbas, Yang Dipertua Pulau Pinang was proclaimed as UNITEN’s Chancellor. In addition, Tan Sri Leo Moggie and Tan Sri Dato’ (Dr.) Ir. Abu Zarim Omar were appointed as UNITEN’s Pro Chancellors.`,
    //         ]
    //     },
    //     {
    //         year: "2007 - 2014",
    //         paragraphs: [
    //             `Dato’ Seri Prof. Mashkuri Yaacob took over the helm as Vice Chancellor on 1 January 2007 and continued where his predecessor had left off. One of his goals was to further strengthen the unity among the staff of UNITEN and he achieved it through the use of the term “sahabat” (companion) when staff address one another, regardless of position or designation.`,
    //         ]
    //     },
    //     {
    //         year: "2015 - 2022",
    //         paragraphs: [
    //             `The incumbent Vice Chancellor, Dato’ Prof. Ir. Dr. Kamal Nasharuddin Mustapha took office on 5 May 2015 and immediately set out to take UNITEN to greater heights. He initiated the drive to transform the campus into a vibrant hive of scholarly and social activities while being “green” at the same time. In the same year, Tan Sri Dr. Ahmad Tajuddin Ali was appointed as UNITEN’s Pro Chancellor.`,
    //         ]
    //     },
    // ]
    // const viceChancllers = [
    //     {
    //         name: "Dr. Tajul Arus bin Noh",
    //         year: "1997-2000",
    //         designation: "UNITEN First Rector"
    //     },
    //     {
    //         name: "Dato’ Prof. Ir. Dr. Zainul Abidin Md. Shariff",
    //         year: "2001 - 2006",
    //         designation: "UNITEN Vice Chancellor"
    //     },
    //     {
    //         name: "Prof. Dato' Seri Ir. Dr. Noor Azuan Abu Osman",
    //         year: "2022 – 2023",
    //         designation: "UNITEN Vice Chancellor"
    //     },
    //     {
    //         name: "Dato’ Seri Prof. Mashkuri Yaacob",
    //         year: "2007 - 2014",
    //         designation: "UNITEN Vice Chancellor"
    //     },
    //     {
    //         name: "Prof. Dato’ Ir. Dr. Kamal Nasharuddin Mustapha",
    //     },
    // ]
    return (
        <div className="flex flex-col gap-5 ">
            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{title}</h1>
            {/* <p className="w-auto text-[#071946B2] text-justify   text-base font-normal leading-normal">{`The Department of Engineering Foundation and General Studies at UNITEN's College of Engineering offers a comprehensive program for aspiring engineers, providing essential skills and a solid foundation in mathematics and sciences. Accredited by MQA, our innovative curriculum, blending theoretical and hands-on learning, prepares students for successful entry into various engineering disciplines. Join us for a rewarding start to your engineering career with a focus on practical skills and real-world application.`}</p>
            <p className="w-auto text-[#071946B2] text-justify   text-base font-normal leading-normal">{`Tenaga Nasional Berhad, or in the early days known as the Central Electricity Board (CEB), has always been committed to the betterment of education in Malaysia. Excellent students were sponsored to pursue their degrees in overseas universities who then serve the company upon the completion of their studies.`}</p> */}
            <p className='w-auto whitespace-pre-line text-white'>{description}</p>
            {/* <Link to="/our people" className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                <span className="text-white text-base font-bold capitalize flex items-center gap-3">Our People <FaArrowRight /></span>
            </Link>
            <div className="grid grid-cols-1 md:grid-cols-2  gap-5">
                {
                    images.map((img, i) => (
                        <img key={i} src={img} className="w-full bg-gray-100 h-auto object-cover aspect-square bg-center rounded-lg  bg-cover bg-no-repeat italic" alt="photo" />
                    ))
                }
            </div>
            <div className="flex flex-col gap-10 border rounded-lg p-6 md:p-8 my-8">
                {
                    history.map((h, index) =>
                        <div key={index} className="flex flex-col gap-5">
                            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{h.year}</h1>
                            {
                                h.paragraphs.map((p, i) => (
                                    <p key={i} className="w-auto  text-justify text-[#071946B2]  text-base font-normal leading-normal">{p}</p>
                                ))
                            }
                        </div>
                    )
                }
                <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">Rector & Vice Chancellors of UNITEN (1997 - Present)</h1>
                {
                    viceChancllers.map((v, i) => (
                        <div key={i} className="flex flex-col gap-3">
                            <p className="w-auto  text-justify text-[#071946B2]  text-base font-normal leading-normal">{v.name}</p>
                            {

                                v.year && v.designation ?
                                    <p className="w-auto  text-justify text-[#071946B2]  text-base font-normal leading-normal">{v.designation}, {v.year}</p>
                                    :
                                    v.year ?
                                        <p className="w-auto  text-justify text-[#071946B2]  text-base font-normal leading-normal">{v.year}</p>
                                        :
                                        v.designation &&
                                        <p className="w-auto  text-justify text-[#071946B2]  text-base font-normal leading-normal">{v.designation}</p>
                            }

                        </div>
                    ))
                }

            </div> */}

        </div>
    )
}
AboutUniten.propTypes = {
    url: PropTypes.string
}
export default AboutUniten